import React, { useState } from "react";
import { FaUser, FaPhone, FaEnvelope, FaLock } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
export default function SignIn() {
    const [name, setName] = useState("");
    const [mobile, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [errors, setErrors] = useState({});
    const validate = () => {
        const errs = {};
        if (!name) errs.name = "Name is required";
        if (!mobile) errs.mobile = "Mobile number is required";
        else if (!/^\d{10}$/.test(mobile))
            errs.mobile = "Mobile number must be 10 digits";
        if (!email) errs.email = "Email is required";
        else if (!/\S+@\S+\.\S+/.test(email)) errs.email = "Invalid email";
        return errs;
    };
    const handleRegister = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {
            alert(`Registered:\nName: ${name}\nMobile: ${mobile}\nEmail: ${email}`);
            setName("");
            setMobile("");
            setEmail("");
        }
    };
    return (
        <div className="page-container">
            <Header />
            <div className="register-right">
                <div className="register-card">
                    <h2 style={{ width: "100%", textAlign: "center" }}>Create Account</h2>
                    <div className="gradient-line"></div>
                    <p className="register-subtitle">Sign up to start Angaaditheru</p>
                    <form onSubmit={handleRegister} className="register-form">
                        <div className="input-group">
                            <FaUser className="input-icon" />
                            <input
                                type="text"
                                placeholder="Full Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)} />
                        </div>
                        {errors.name && <p className="error-msg">{errors.name}</p>}
                        <div className="input-group">
                            <FaPhone className="input-icon" />
                            <input
                                type="text"
                                placeholder="Mobile Number"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)} />
                        </div>
                        {errors.mobile && <p className="error-msg">{errors.mobile}</p>}
                        <div className="input-group">
                            <FaEnvelope className="input-icon" />
                            <input
                                type="email"
                                placeholder="Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        {errors.email && <p className="error-msg">{errors.email}</p>}
                        <button type="submit" className="register-btn">Register</button>
                        <p className="login-link">Already have an account? <a href="/signin">Login</a></p>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}